import CompletedFooter from "./components/CompletedFooter";
import CompletedHeader from "./components/CompletedHeader";
import CompletedTodoList from "./components/CompletedTodoList";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";

function App() {
    return (
        <div style={{ paddingTop: "80px", paddingBottom: "40px", minHeight: "100vh" }} className="grid place-items-center bg-blue-100 px-6 font-sans">
            <Navbar />

            <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
                <Header />

                <hr className="mt-4" />

                <TodoList />

                <hr className="mt-4" />

                <Footer />
            </div>

            <div style={{ marginTop: "30px" }} className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
                <CompletedHeader />

                <hr className="mt-4" />

                <CompletedTodoList />

                <hr className="mt-4" />

                <CompletedFooter />
            </div>
        </div>
    );
}

export default App;
